import {
  type RunsDataQueryConfig,
  toRunsDataQueryConfig,
} from '../../containers/RunsDataLoader';
import {createPreloadableLazyComponent} from '../../util/lazyImport';
import {useSampleAndQueryToTable} from '../../util/panelHelpers';
import type {PanelSpec} from '../../util/panelTypes';
import {type Query} from '../../util/queryTypes';
import {parseExpressions} from '../PanelExpressionOptions';
import {
  getTitleFromConfig,
  type ScalarChartConfig,
  scalarChartTransformQuery,
} from './common';
export type {ScalarChartConfig};

const PANEL_TYPE = 'Scalar Chart';

// We don't want the panel infrastructure to do the query for us, since the query
// we make depends on internal state. So we disable the
// outer query, and do our own query inside the panel.
const transformQuerySkip = (
  query: Query,
  config: ScalarChartConfig
): RunsDataQueryConfig => {
  const result = toRunsDataQueryConfig(query, undefined, {
    panelType: PANEL_TYPE,
  });
  result.disabled = true;
  return result;
};

const useTableData = (pageQuery: Query, config: ScalarChartConfig) => {
  const query = scalarChartTransformQuery(
    pageQuery,
    config,
    parseExpressions(config.expressions, undefined)
  );
  return useSampleAndQueryToTable(query, pageQuery, config);
};

export const Spec: PanelSpec<typeof PANEL_TYPE, ScalarChartConfig> = {
  type: PANEL_TYPE,
  Component: createPreloadableLazyComponent(() => import('./ComponentWrapper'))
    .Component,
  getTitleFromConfig,
  transformQuery: transformQuerySkip,
  useTableData,

  exportable: {
    image: true,
    csv: true,
    api: true,
  },

  configSpec: {
    chartTitle: {editor: 'string', displayName: 'Chart title'},
    xAxisMin: {editor: 'number', displayName: 'X min'},
    xAxisMax: {editor: 'number', displayName: 'X max'},
  },

  icon: 'panel-number',
};
